/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SaveTemplateRequest model module.
 * @module model/SaveTemplateRequest
 * @version V1
 */
class SaveTemplateRequest {
    /**
     * Constructs a new <code>SaveTemplateRequest</code>.
     * @alias module:model/SaveTemplateRequest
     * @param name {String} 
     * @param subject {String} 
     * @param html {String} 
     * @param bccUserIds {Array.<Number>} 
     */
    constructor(name, subject, html, bccUserIds) { 
        
        SaveTemplateRequest.initialize(this, name, subject, html, bccUserIds);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, name, subject, html, bccUserIds) { 
        obj['name'] = name;
        obj['subject'] = subject;
        obj['html'] = html;
        obj['bccUserIds'] = bccUserIds;
    }

    /**
     * Constructs a <code>SaveTemplateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SaveTemplateRequest} obj Optional instance to populate.
     * @return {module:model/SaveTemplateRequest} The populated <code>SaveTemplateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SaveTemplateRequest();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('subject')) {
                obj['subject'] = ApiClient.convertToType(data['subject'], 'String');
            }
            if (data.hasOwnProperty('html')) {
                obj['html'] = ApiClient.convertToType(data['html'], 'String');
            }
            if (data.hasOwnProperty('bccUserIds')) {
                obj['bccUserIds'] = ApiClient.convertToType(data['bccUserIds'], ['Number']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SaveTemplateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SaveTemplateRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of SaveTemplateRequest.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['subject'] && !(typeof data['subject'] === 'string' || data['subject'] instanceof String)) {
            throw new Error("Expected the field `subject` to be a primitive type in the JSON string but got " + data['subject']);
        }
        // ensure the json data is a string
        if (data['html'] && !(typeof data['html'] === 'string' || data['html'] instanceof String)) {
            throw new Error("Expected the field `html` to be a primitive type in the JSON string but got " + data['html']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['bccUserIds'])) {
            throw new Error("Expected the field `bccUserIds` to be an array in the JSON data but got " + data['bccUserIds']);
        }

        return true;
    }


}

SaveTemplateRequest.RequiredProperties = ["name", "subject", "html", "bccUserIds"];

/**
 * @member {String} name
 */
SaveTemplateRequest.prototype['name'] = undefined;

/**
 * @member {String} subject
 */
SaveTemplateRequest.prototype['subject'] = undefined;

/**
 * @member {String} html
 */
SaveTemplateRequest.prototype['html'] = undefined;

/**
 * @member {Array.<Number>} bccUserIds
 */
SaveTemplateRequest.prototype['bccUserIds'] = undefined;






export default SaveTemplateRequest;

